import HomePage from 'components/pages/Home';

import { fetchHomePills } from 'lib/homePills';
import { toAbsoluteLink } from 'lib/links';
import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getBestOffersList, getFeaturedOffersList } from 'services/offer';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';

const CANONICAL_URL = toAbsoluteLink(LINKS.TREND_OFFERS);
const DESCRIPTION =
  'Os favoritos da comunidade do Promobit: descontos reais mais populares em smartphones, TVs, moda, jogos, tablets, consoles, notebooks e muito mais, validados por quem usa.';
const OFFERS_SERVER_LIMIT = 12;
const PAGE_H1 = 'Favoritos da Comunidade';
const PAGE_TITLE =
  'Favoritos da Comunidade: Descontos reais mais populares | Promobit';
const TAB_NAME = 'trend';

const EmAlta = ({
  cardsAds,
  landscapeAds,
  recoveryPassword,
  serverFeaturedOffers,
  serverHomePills,
  serverHomePillsTitle,
  serverOffers,
  smallAds,
}) => (
  <HomePage
    canonicalUrl={CANONICAL_URL}
    cardsAds={cardsAds}
    description={DESCRIPTION}
    h1Text={PAGE_H1}
    landscapeAds={landscapeAds}
    pageTitle={PAGE_TITLE}
    recoveryPassword={recoveryPassword}
    serverFeaturedOffers={serverFeaturedOffers}
    serverHomePills={serverHomePills}
    serverHomePillsTitle={serverHomePillsTitle}
    serverOffers={serverOffers}
    smallAds={smallAds}
  />
);

export const getServerSideProps = async ({ query }) => {
  try {
    const [
      serverOffers,
      serverFeaturedOffers,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          cardAd: cardsAds = [],
          homeAd: landscapeAds = [],
          smallAd: smallAds = [],
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getBestOffersList({
        limit: OFFERS_SERVER_LIMIT,
        ...query,
      }),
      { fn: getFeaturedOffersList(), fallback: getFeaturedOffersList.fallback },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    const { serverHomePills, serverHomePillsTitle } = await fetchHomePills();

    return {
      props: {
        cardsAds,
        landscapeAds,
        serverFeaturedOffers,
        serverHomePills,
        serverHomePillsTitle,
        serverOffers,
        smallAds,
        [APP.CTX_OPTIONAL_PROPS]: {
          activeOffersListTab: TAB_NAME,
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[500], permanent: false } };
  }
};

export default EmAlta;
